import styled from "styled-components";

export const PropertySellersWrapper = styled.div`
  width: 560px;
  margin: auto;
`;
